import Skeleton from '@carvana/ds-skeleton';
import cx from 'classnames';
import LiveAnnouncer from '@/common/LiveAnnouncer';
import FilterMenuChip from '@/srp/FilterMenuChip';
import { usePagination } from '@/srp/ResultsSection/hooks';
import { useShowComposerTreatment } from '~/context/composer/ComposerContext';
import { useInventoryIsLoaded } from '~/context/srp/InventoryContext';
import GeoLocationButton from './GeoLocationButton';
import SaveSearch from './SaveSearch';
import { Bar } from './SearchTools.styles';
import SortBy from './SortBy';

export default function SearchTools() {
  const {
    pagination: { totalMatchedInventory = 0 }
  } = usePagination();
  const isInventoryLoaded = useInventoryIsLoaded();
  const showComposerTreatment = useShowComposerTreatment();
  const resultsCountText = `${totalMatchedInventory.toLocaleString()} cars`;

  return (
    <div
      id="search-tools"
      data-testid="srp-search-tools"
      className="my-2xl flex items-center justify-between sm:my-3xl"
    >
      {isInventoryLoaded ? (
        <p
          aria-busy="false"
          className="text-text-weak t-body-sm"
          data-testid="results-count"
        >
          {resultsCountText}
        </p>
      ) : (
        <Skeleton
          aria-busy="true"
          data-testid="results-count-skeleton"
          height="20px"
          width="96px"
        />
      )}
      <LiveAnnouncer message={isInventoryLoaded ? resultsCountText : ''} />
      <span
        className={cx(
          'flex items-center',
          showComposerTreatment ? 'gap-[6px]' : 'gap-lg'
        )}
      >
        <GeoLocationButton />
        <Bar />
        <SortBy />
        <Bar />
        <SaveSearch />
        {showComposerTreatment && (
          <FilterMenuChip
            className="px-lg py-md rounded-round"
            dataAnalyticsAttributes={JSON.stringify({ source: 'page' })}
          />
        )}
      </span>
    </div>
  );
}
